import ScheduledPayrollCards from './ScheduledPayrollCards';

export default ScheduledPayrollCards;
